"use client";
import { useEffect, useRef } from "react";
import "../../app/globals.css";

const TrustpilotWidget = ({
  bgColor = "#D9E8F1", // Default background color
  textColor = "#5C2483" // Default text color (for any potential text outside widget)
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const loadWidget = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(ref.current, true);
      } else {
        setTimeout(loadWidget, 300);
      }
    };

    loadWidget();
  }, []);

  return (
    // This is the outer container that provides the custom background and shape
    <div
      className="trustpilot-widget-container py-[clamp(4px,0.5vw,6px)]"
      style={{
        "--widget-bg-color": bgColor,
        "--widget-text-color": textColor
      }}
    >
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="sv-SE"
        data-template-id="5419b637fa0340045cd0c936"
        data-businessunit-id="67a5e908db89fc000f845887"
        data-style-height="24px"
        data-style-width="230px"
        data-theme="light"
        data-token="ed3b84d6-a47d-47e8-83db-cf6446e26025"
      >
        <a
          href="https://se.trustpilot.com/review/finansfabriken.se"
          target="_blank"
          rel="noopener"
          onClick={(e) => {
            if (!window.Trustpilot) {
              e.preventDefault();
              window.open(
                "https://se.trustpilot.com/review/finansfabriken.se",
                "_blank",
                "noopener,noreferrer"
              );
            }
          }}
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
};

export default TrustpilotWidget;
